import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getLocations } from "../../repositories/LocationRepository";
import { useLocationContext } from "./LocationContext";
import { TableLocation } from "./components/TableLocation";

type Props = {};

export const LocationPage = (props: Props) => {
  const { actions } = useLocationContext();
  const { locationId } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const getLocationsFromAPI = async () => {
    setIsLoading(true);
    const resp = await getLocations();
    if (resp.ok) {
      const locations = get(resp, "data.tables[0].rows", []);
      actions.setLocations(locations);
    } else {
      setError(resp.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getLocationsFromAPI();
  }, []);

  return (
    <>
      <HelmetDexteel title={"Locations"} />
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={12} xs={12} style={{ margin: 0 }}>
          <Paper
            elevation={1}
            style={{
              width: "100%",
              padding: "10px 0 20px",
              borderRadius: "0.75rem",
              height: "auto",
            }}
          >
            <TableLocation
              locationId={locationId}
              isLoading={isLoading}
              getLocationsFromAPI={getLocationsFromAPI}
            />
          </Paper>
        </Grid>
      </Grid>
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
